/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-unresolved */
import {
    Breadcrumb, Button, Panel, Tab, Tabs,
} from 'appkit-react';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import FFIEC041ClassifyResult from './FFIEC041ClassifyResult';
import FFIEC041AduitLogs from '../containers/FFIEC041AduitLogs';
import FFIEC041Comments from '../containers/FFIEC041Comments';
import FFIEC041ResultsAccordian from './FFIEC041ResultsAccordian';
import '../styles/ffiec041.scss';

const FFIEC041Results = ({
    auditLog, breadcrumbItems, refetch, onNavigate, criteria, pages, pagesize,
    setPageSize, setPageNumber, pageSizeOptions, fetchData, data, columns,
}) => {
    const history = useHistory();
    const [showClassifyResult, setShowClassifyResult] = useState(false);

    return (
        <>

            <div className="true-comply-ffiec041-results_layout">
                <div className="true-comply-ffiec041-results_column-2">
                    <Breadcrumb items={breadcrumbItems} />
                    <Row>
                        <Col md={4}>
                            <div className="a-h2 title-label">
                                <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={() => history.goBack()} role="presentation" />
                                {`Rule #${(criteria && criteria.ruleId) ? criteria.ruleId : ''} Results`}
                            </div>
                        </Col>
                        <Col className="classyfy_btn_container">
                            <Row>
                                <Col style={{ textAlign: 'right' }}>
                                    <span>
                                        <Button size="lg" style={{ marginLeft: '1rem' }} onClick={() => setShowClassifyResult(true)}>
                                            CLASSIFY RESULTS
                                        </Button>
                                        {showClassifyResult
                                            && (
                                                <FFIEC041ClassifyResult
                                                    setShowClassifyResult={setShowClassifyResult}
                                                    refetch={auditLog.refetch}
                                                    refetchTestData={refetch}
                                                />
                                            )}
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    { /* import results accordian */ }
                    <FFIEC041ResultsAccordian
                        criteria={criteria}
                        columns={columns}
                        fetchData={fetchData}
                        data={data}
                        pages={pages}
                        pagesize={pagesize}
                        setPageSize={setPageSize}
                        setPageNumber={setPageNumber}
                        pageSizeOptions={pageSizeOptions}
                    />

                    <Panel style={{ marginTop: '1rem', marginBottom: '2rem' }}>
                        <Tabs defaultValue="2" className="a-tab-item-padding-10" size="md">
                            {/* <Tab value="1" label="REMEDIATION">
                                {remediation && remediation.length ? <Remediation failedTestsData={failedTestsData} refetch={auditLog.refetch} /> : (
                                    <div className="a-h4">
                                        Remediation is not allowed for passed test cases
                                    </div>
                                )}
                            </Tab> */}
                            <Tab value="2" label="COMMENTS">
                                <FFIEC041Comments refetch={auditLog.refetch} />
                            </Tab>
                            <Tab value="3" label="AUDIT LOG">
                                <FFIEC041AduitLogs data={auditLog.data && auditLog.data.getAuditLogsForFFIEC041} />
                            </Tab>
                        </Tabs>
                    </Panel>
                </div>
            </div>
        </>
    );
};

export default FFIEC041Results;
